import React from "react";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import { Col, Row } from "react-bootstrap";

export default function ChallengeItemsList({
    challengeItems,
    onAdd: addInfo,
    onRemove: handleRemove,
    onInsert: handleInsert,
    onMoveUp: handleMoveUp,
    onMoveDown: handleMoveDown,
    onChange: handleChange,
}) {
    if (!challengeItems || challengeItems.length === 0) return null;

    return (
        <div className="mb-3">
            <Form.Label className="fw-semibold">Challenge Items</Form.Label>
            {challengeItems.map((challengeItem, idx) => (
                <Row key={challengeItem.id} className="mb-2 align-items-center">
                    <Form.Group as={Col} md="1">
                        <Button
                            type="button"
                            size="sm"
                            onClick={() => addInfo(idx)}
                            variant={challengeItem.info ? "success" : "outline-primary"}
                        >
                            info
                        </Button>
                    </Form.Group>
                    <Form.Group as={Col} md="7">
                        <Form.Control
                            type="text"
                            placeholder={`Challenge Item #${idx + 1}`}
                            value={challengeItem.item}
                            onChange={handleChange(idx)}
                        />
                    </Form.Group>
                    <Form.Group as={Col} md="4" className="d-flex gap-1">
                        <Button type="button" size="sm" variant="outline-danger" onClick={handleRemove(idx)}>−</Button>
                        <Button type="button" size="sm" variant="outline-secondary" onClick={handleInsert(idx)}>+</Button>
                        <Button type="button" size="sm" variant="outline-secondary" onClick={handleMoveUp(idx)}>↑</Button>
                        <Button type="button" size="sm" variant="outline-secondary" onClick={handleMoveDown(idx)}>↓</Button>
                    </Form.Group>
                </Row>
            ))}
        </div>
    );
}
